import { usePartner } from 'thermia-react-container';
import {OnBehalfOfService} from "../../../service/onBehalfOfService";
import {Partner} from "thermia-react-container/types/types/partner";
import {useIsAdmin} from "../../../hooks/useIsAdmin";
import {PartnerInfo} from "../../../types/registrationTypes";

/**
 * Hook to get either the OnBehalfOfService partner mapped to a Partner
 * model partner if admin or the actual partner from context if not.
 */
export function useCurrentPartner() {
  const actualPartner = usePartner();
  const isAdmin = useIsAdmin();
  const PartnerInfoToPartnerMap = (partnerInfo: PartnerInfo): Partner => {
    return ({
      id: partnerInfo.id,
      customerId: partnerInfo.customerId,
      name: partnerInfo.companyName,
      market: partnerInfo.salesArea?.market ?? '',
      businessArea: partnerInfo.salesArea?.region ?? '',
      partnerLevel: '',
    } as Partner)
  }

  return isAdmin && OnBehalfOfService.partner ?
    PartnerInfoToPartnerMap(OnBehalfOfService.partner)
    : actualPartner
}
